var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.118,12.401l11.653,-11.657l3.536,3.535l-11.683,11.687l11.588,11.78l-3.565,3.507l-11.558,-11.751l-11.653,11.656l-3.536,-3.535l11.683,-11.686l-11.588,-11.781l3.565,-3.506l11.558,11.751Z","fill":"currentColor"}));
}

Cross.defaultProps = {"width":"20","height":"20","viewBox":"0 0 32 32","version":"1.1"};

module.exports = Cross;

Cross.default = Cross;
